import { render, staticRenderFns } from "./LatestUpdates.vue?vue&type=template&id=27e60644&scoped=true"
import script from "./LatestUpdates.vue?vue&type=script&lang=js"
export * from "./LatestUpdates.vue?vue&type=script&lang=js"
import style0 from "./LatestUpdates.vue?vue&type=style&index=0&id=27e60644&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e60644",
  null
  
)

export default component.exports